import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  EnableTemporaryOTPModalComponent
} from "./2fa-modals/enable-temporary-otp-modal/enable-temporary-otp-modal.component";
import {TemporaryOTPModalComponent} from "./2fa-modals/temporary-otp-modal/temporary-otp-modal.component";
import {OtpInputComponent} from "./otp-input/otp-input.component";
import {FormsModule} from "@angular/forms";
import {SharedModule} from "../shared/shared.module";



@NgModule({
  declarations: [
    EnableTemporaryOTPModalComponent,
    TemporaryOTPModalComponent,
    OtpInputComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
  ]
})
export class TwoFactorModule { }
